import {
  GET_TRANSFEREE_SUMMARIES_FAILURE,
  getAuthorizationSearchResults,
  setActiveTransfereeTab,
  getTransfereeSummaries,
} from './transferees.actions';

import { getClientInformation } from '../authorizations/authorizations.actions';

import {
  TOAST_MESSAGE_SEVERITY_ERROR,
  setPageTitle,
  showToast,
} from '../layout/layout.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import { Box, Button } from '@material-ui/core';
import { getSelectedClientInformation, getUserName } from 'utilities/authUtils';
import Transferees from './transferees.component';
import FullscreenSpinner from 'common/fullscreenSpinner.component';

class TransfereesContainer extends Component {
  constructor(props) {
    super(props);

    this.handleViewSubmittedAuth = this.handleViewSubmittedAuth.bind(this);
  }

  async componentDidMount() {
    this.props.setPageTitle('My Transferees');
    const action = await this.props.getTransfereeSummaries(getSelectedClientInformation().id);
    if (action.type === GET_TRANSFEREE_SUMMARIES_FAILURE) {
      this.props.showToast('Failed to load transferees.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR,
      });
    }
    this.props.getClientInformation(parseInt(getSelectedClientInformation().id));
    this.props.setActiveTransfereeTab(0);
  }

  handleViewSubmittedAuth(id) {
    this.props.history.push(`/transferees/${encodeURIComponent(id)}`);
  }

  render() {
    const { authorizationSearchResults, isLoading } = this.props;

    /* Removed due to request for AB#1401: adding 'Extended Service' status
        const initialFilters = get(location.state, 'filterActive', false) ? [{
      columnName: 'StatusGrouping',
      value: 'Active' || 'Extended Service',
      operation: 'contains',
    }] : [];
    */ 
    let hasConfidentialFileAccess = false;
    if(this.props.clientInfo && this.props.clientInfo.clientContacts && this.props.clientInfo.clientContacts.length > 0) {
      let currentToken = getUserName();
      let currentUser = this.props.clientInfo.clientContacts.find((contact) => contact.contact.auth0UserId === currentToken);
      if(currentUser) {
        hasConfidentialFileAccess = currentUser.contact.hasConfidentialFileAccess;
      }
    }

    return (
      <>
        {isLoading ? (
          <FullscreenSpinner />
        ) : (
          <div style={{ padding: "2rem" }}>
            {getSelectedClientInformation().id === "238" ? (
              <Button
                variant="contained"
                size="small"
                color="primary"
                style={{ float: "right" }}
                onClick={() =>
                  this.props.history.push(
                    "reporting/mpcauthorizations?StatusGrouping=Active"
                  )
                }
              >
                Export
              </Button>
            ) : null}
            <Box padding="3rem 0 0" height="100%" width="100%">
              <Transferees
                rows={authorizationSearchResults}
                handleViewSubmittedAuth={this.handleViewSubmittedAuth}
                hasConfidentialFileAccess={hasConfidentialFileAccess}
              />
            </Box>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorizationSearchResults: state.transferees.get('authorizationSearchResults'),
    isLoading: state.transferees.get('isLoading'),
    clientInfo: state.authorizations.get('clientInfo'),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    getAuthorizationSearchResults,
    setActiveTransfereeTab,
    getTransfereeSummaries,
    getClientInformation,
  })(TransfereesContainer),
);
 